export const type = {
	view360: 0,
	hotspot: 1,
};

export const typeNameCard = {
	center_cultural: "Centro cultural",
	claustro: "Claustro de CyAD",
	sound_space: "Espacio sonoro",
	library: "Bibloteca",
	gardenEden: "Jardín Edén",
	gardenInit: "Jardín entrada",
	gardenPicNic: "Jardín PicNic",
	cafeteria: "Cafetería",
	sportActive: "Actividades deportivas",
};
